module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/~/babel-runtime/core-js/object/define-property.js
 ** module id = 582
 ** module chunks = 0
 **/